import React from 'react';
import { FiTrash } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components/macro';

interface Props {
  onClick: any;
  className?: string;
}

const RemoveButton = ({ onClick, className }: Props) => {
  const { t } = useTranslation();

  return (
    <StyledRemoveButton onClick={onClick} className={className}>
      <div className="flex flex-col justify-center items-center ">
        <div className="self-center relative">
          <FiTrash className="text-red-dark h-8 w-8" />
        </div>
        <div className="sethidden text-gray-700 xl:block">{t('Remove')}</div>
      </div>
    </StyledRemoveButton>
  );
};

export default RemoveButton;

const StyledRemoveButton = styled.button`
  padding: 0.5rem;
`;
